import { useState } from 'react';
import { Button, Col, Row, Form, Card, CardBody } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { setPassword } from '~/services/account';
import { useForm } from 'react-hook-form';
import { TextInput } from '~/shared/components/form/Inputs';
import { getDashColor } from '~/shared/components/icons';
import toast from 'react-hot-toast';

export const Password = () => {
    const [saving, setSaving] = useState(false);
    const {
        control,
        handleSubmit,
        reset,
        setValue,
        getValues,
        register,
        watch,
        formState: { errors, isSubmitting, isValid },
    } = useForm({
        defaultValues: {
            password: '',
            password_confirmation: '',
        },
        mode: 'onChange',
    });
    const history = useHistory();

    const onSubmit = async (data) => {
        try {
            setSaving(true);
            const payload = data.password;
            const resp = await setPassword(payload);
            if (resp.detail) {
                toast.error(resp.detail);
            } else {
                toast.success('Password saved');
                history.push('/profile');
            }
        } catch (e) {
            console.log('e: ', e);
            setSaving(false);
            return;
        }
    };

    return (
        <div className='container__inner'>
            <div className='mb-5'>
                <h1 className='h2'>Change Password</h1>
            </div>
            <div className='mb-5'>
                <Row>
                    <Col lg={6} className='mb-4 mb-lg-0'>
                        <Card className='border'>
                            <CardBody>
                                <Form onSubmit={handleSubmit(onSubmit)}>
                                    <TextInput
                                        name='password'
                                        type='password'
                                        label='Password'
                                        control={control}
                                        errors={errors?.password?.message}
                                        required={true}
                                        ariaRequired={true}
                                    />
                                    <TextInput
                                        name='password_confirmation'
                                        label='Confirm Password'
                                        type='password'
                                        control={control}
                                        errors={
                                            errors?.password_confirmation
                                                ?.message
                                        }
                                        required={true}
                                        ariaRequired={true}
                                        validate={(val: string) => {
                                            if (watch('password') != val) {
                                                return 'Your passwords do no match';
                                            }
                                        }}
                                    />
                                    <Button
                                        color='outline-dark'
                                        onClick={() => history.goBack()}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        color='primary'
                                        type='submit'
                                        disabled={isSubmitting || !isValid}
                                    >
                                        {saving ? `Saving` : `Save`}
                                    </Button>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col lg={6}>
                        <Card
                            style={{
                                background: getDashColor('supporters'),
                            }}
                        >
                            <CardBody>
                                <p>Password Rules:</p>
                                <ul>
                                    <li>
                                        Passwords must be at least 8 characters
                                    </li>
                                    <li>
                                        Include a mix of letters and special
                                        characters
                                    </li>
                                    <li>
                                        Avoid using common words or easily
                                        guessable information
                                    </li>
                                </ul>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </div>
    );
};
